


















































































































import { ConfirmModal } from '@/app/components';
import { useFilters } from '@/app/composable';
import { AssetTypeIcon } from '@/modules/asset/components';
import { AssetType, AssetTypeId } from '@/modules/asset/constants';
import { Icon } from '@iconify/vue2';
import { PropType, Ref, computed, defineComponent, ref } from '@vue/composition-api';
import dayjs from 'dayjs';
import minMax from 'dayjs/plugin/minMax';
import utc from 'dayjs/plugin/utc';
import { match } from 'ts-pattern';
import { RetrievalAccessibility, RetrievalStatus } from '../constants';
import { RetrievalQuery } from '../interfaces';
dayjs.extend(utc);
dayjs.extend(minMax);

export default defineComponent({
    name: 'RetrievalQueryCard',
    props: {
        retrievalQuery: {
            type: Object as PropType<RetrievalQuery>,
            required: true,
        },
        canDelete: {
            type: Boolean,
            default: true,
        },
    },
    components: { Icon, AssetTypeIcon, ConfirmModal },
    setup(props) {
        const { formatDateAs } = useFilters();
        const showDeleteModal: Ref<boolean> = ref<boolean>(false);
        const { formatDateTime } = useFilters();

        const assetType = (typeId: number) => {
            switch (typeId) {
                case AssetTypeId.Model:
                    return AssetType.Model;
                case AssetTypeId.Result:
                    return AssetType.Result;
                default:
                    return AssetType.Dataset;
            }
        };

        const statusLabel = computed(() =>
            match<RetrievalStatus, string>(props.retrievalQuery.status)
                .with(RetrievalStatus.Available, () => 'Retrieval query is available')
                .with(RetrievalStatus.Configuration, () => 'Retrieval query is under configuration')
                .with(RetrievalStatus.Deprecated, () => 'Retrieval query has been deprecated')
                .with(RetrievalStatus.Unavailable, () => 'Retrieval query is unavailable')
                .exhaustive(),
        );
        const statusIcon = computed(() =>
            match<RetrievalStatus, string>(props.retrievalQuery.status)
                .with(RetrievalStatus.Available, () => 'solar:check-circle-bold')
                .with(RetrievalStatus.Configuration, () => 'solar:menu-dots-circle-bold')
                .with(RetrievalStatus.Deprecated, () => 'solar:archive-bold')
                .with(RetrievalStatus.Unavailable, () => 'solar:forbidden-circle-bold')
                .exhaustive(),
        );
        const statusClass = computed(() =>
            match<RetrievalStatus, string>(props.retrievalQuery.status)
                .with(RetrievalStatus.Available, () => 'text-green-700')
                .with(RetrievalStatus.Configuration, () => 'text-purple-600')
                .with(RetrievalStatus.Deprecated, () => 'text-cherry-700')
                .with(RetrievalStatus.Unavailable, () => 'text-neutral-600')
                .exhaustive(),
        );
        return {
            dayjs,
            RetrievalStatus,
            RetrievalAccessibility,
            showDeleteModal,
            statusLabel,
            statusIcon,
            statusClass,
            formatDateAs,
            assetType,
            formatDateTime,
        };
    },
});
